var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.273 4.227 12.972.165c-.162-.189-.449-.226-.628-.057-.18.17-.216.47-.054.658l3.068 3.78c-.018 0-.036-.019-.054-.019H.95a.455.455 0 0 0-.449.47c0 .264.197.47.449.47h14.337c.018 0 .036-.018.054-.018l-3.068 3.78a.47.47 0 0 0 .34.771.434.434 0 0 0 .342-.17l3.301-4.061c.323-.376.323-1.166.018-1.542z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.c3f2714a788400106310f786dcfd8268.svg";
export { ForwardRef as ReactComponent };